import React from "react";
import { useQuery } from "@tanstack/react-query";
import { axiosget } from "../../helpers/httprequest";
import { FaBook,  FaSearch } from "react-icons/fa";
import PageTitle from "../../components/PageTitle";
import Loader from "../../components/Loader";
import ErrorResponse from "../../components/ErrorResponse";
// import ViewMaterials from "./ViewMaterials";
import "./Materials.css";
import { Link } from "react-router-dom";

const Materials = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["registeredCoursesMaterials"],
    queryFn: async () => {
      const req = await axiosget(`ms_course`);
      return req?.data;
    },
  });

  const [searchTerm, setSearchTerm] = React.useState("");

  const filteredData =
    data?.filter(
      (course) =>
        course?.courseinfo?.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        course?.courseinfo?.code.toLowerCase().includes(searchTerm.toLowerCase())
    ) || [];

  return (
    <div className="materials-container">
      <PageTitle title="My Learning Materials" sub="Access all your course materials in one place" />

      {/* Search and Filter Section */}
      <div className="materials-search-container">
        <div className="search-input-group">
          <FaSearch className="search-icon" />
          <input
            type="text"
            placeholder="Search courses by name or code..."
            className="search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="materials-count">
          {filteredData.length} {filteredData.length === 1 ? "course" : "courses"} found
        </div>
      </div>

      {/* Loading and Error States */}
      {isLoading && <Loader />}
      {error && <ErrorResponse type="danger" message={`Error: ${error.message}`} />}
      {data?.type !== undefined && <ErrorResponse type="danger" message={data?.message} />}
      {!isLoading && filteredData.length === 0 && (
        <div className="empty-state">
          <FaBook className="empty-icon" />
          <h3>No Materials Available</h3>
          <p>You currently don't have any course materials to display</p>
        </div>
      )}

      {/* Course Materials Grid */}
      <div className="materials-grid">
        {filteredData?.map((course, index) => (
          <CourseCard key={`course-material-${index}`} course={course} />
        ))}
      </div>
    </div>
  );
};

const CourseCard = ({ course }) => {
  
  return (
    <Link className="course-card" style={{ textDecoration: "none" }} to={`/app/resources/${course?.courseinfo?._id}`}>
      <div className="course-header">
        <FaBook className="course-icon" />
        <div>
          <h3 className="course-code">{course?.courseinfo?.code}</h3>
          <h2 className="course-title">{course?.courseinfo?.name}</h2>
        </div>
      </div>

      <div className="course-details">
        <div className="detail-item">
          <span className="detail-label">Level:</span>
          <span className="detail-value">{course?.courseinfo?.level}</span>
        </div>
        <div className="detail-item">
          <span className="detail-label">Semester:</span>
          <span className="detail-value">{course?.courseinfo?.semester}</span>
        </div>
        <div className="detail-item">
          <span className="detail-label">Credits:</span>
          <span className="detail-value">{course?.courseinfo?.credit} Units</span>
        </div>
        <div className="detail-item">
          <span className="detail-label">Session:</span>
          <span className="detail-value">{course?.session?.name}</span>
        </div>
      </div>
    </Link>
  );
};

export default Materials;
